import styles from "./AppliedFilter.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import type { ClearFilterFn, ClearFilterKey } from "./FilterInterface";

interface Props {
  title: string;
  multiValues?: any[];
  singleValues?: any;
  idKey?: string;
  nameKey?: string;
  filterKey: ClearFilterKey;
  clearFilter: ClearFilterFn;
}

const closeIcon = <CloseIcon fontSize="small" />;

const FilterChip = ({
  title,
  multiValues,
  singleValues,
  idKey,
  nameKey,
  filterKey,
  clearFilter,
}: Props) => {
  const hasMulti = multiValues && multiValues?.length > 0;
  const hasSingle = !!singleValues;

  if (!hasMulti && !hasSingle) return null;

  return (
    <div className="flex items-center gap-4 ml-4">
      <div className={styles.filtersModeHead}>
        <span>{title}</span>

        <button
          type="button"
          className={styles.customClose}
          onClick={() => clearFilter(filterKey)}
        >
          {closeIcon}
        </button>
      </div>

      {multiValues?.map((item, index) => (
        <div key={idKey ? item?.[idKey] : index} className={styles.filtersMode}>
          <div className="inline-block">
            {nameKey ? item?.[nameKey] : item}
          </div>

          <button
            type="button"
            className={styles.customClose}
            onClick={() => clearFilter(filterKey, "", index)}
          >
            {closeIcon}
          </button>
        </div>
      ))}

      {singleValues && (
        <div className={styles.filtersMode}>
          <div className="inline-block">
            {nameKey ? singleValues?.[nameKey] : singleValues}
          </div>

          <button
            type="button"
            className={styles.customClose}
            onClick={() => clearFilter(filterKey)}
          >
            {closeIcon}
          </button>
        </div>
      )}
    </div>
  );
};

export default FilterChip;